<template>
  <div>
    <Sidebar />
    <Content :id="$route.params.id" mode='edit' />
  </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import Sidebar from '@/components/Sidebar.vue'; // @ is an alias to /src
import Content from '@/components/NotificationEdit.vue'; // @ is an alias to /src

@Component({
  components: {
    Sidebar,
    Content,
  },
})
export default class NotificationEdit extends Vue {}
</script>
